var ContextMenu = (() => {
    var _this;

    function reveal($contextMenu) {
        let items, nav, navTop, bottom, limit;

        if (!$contextMenu.hasClass('isDown') || ($contextMenu.closest('.dialog').length > 0)) {
            return;
        }

        items = $contextMenu.find('.context-menu-items')[0];

        if (!items) {
            return;
        }

        bottom = $contextMenu[0].getBoundingClientRect().bottom + items.offsetHeight;
        limit = window.innerHeight;

        nav = document.querySelector('nav.main');
        navTop = nav ? nav.getBoundingClientRect().top : limit;

        if ((navTop > (window.innerHeight / 2)) && (navTop < limit)) {
            limit = navTop;
        }

        if (bottom > limit) {
            AnimationHandler.scrollTo(AnimationHandler.getScrollTop() + (bottom - limit), false, $contextMenu);
        }
    }

    _this = {
        closeAll: function() {
            $('.context-menu.isOpen').removeClass('isOpen').closest('.context-menu-parent').removeClass('hasOpenContextMenu');
        }
    };

    $(document).on('click', '.context-menu-toggle', function(event) {
        var $contextMenu, isOpen;

        event.stopPropagation();
        event.preventDefault();

        $contextMenu = $(this).closest('.context-menu');

        isOpen = !$contextMenu.hasClass('isOpen');

        setTimeout(() => {
            _this.closeAll();
            $contextMenu.toggleClass('isOpen', isOpen).closest('.context-menu-parent').toggleClass('hasOpenContextMenu', isOpen);

            if (isOpen) {
                reveal($contextMenu);
            }
        }, 0);
    });

    return _this;
})();
